import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Cancel(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="10,3.935 8.333,2.267 5,5.6 1.667,2.267 0,3.935 3.333,7.267 0,10.6 1.667,12.267 5,8.934 8.333,12.267 10,10.6 6.667,7.267" />
        </SvgIcon>
    );
}

Cancel.defaultProps = {
    viewBox: '0 0 10 16'
};

export default Cancel;
